import React from "react";
import styled from "styled-components";
// Component , { Fragment }
import { Link as RouterLink, useLocation } from "react-router-dom";
import PremiumIcon from "app/images/premium.svg";
// import { signInWithGoogle } from "../firebase/firebase.utils";
import "./Navbar.style.css";

import { AppBar, Toolbar, Link } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import Typography from "@material-ui/core/Typography";
import {
  AccountCircle as AccountCircleIcon,
  Flare as FlareIcon, // Changed from AutoFixHigh
  Assessment as AssessmentIcon,
} from "@material-ui/icons";

import Menu from "./Menu";
import Unlock from "features/unlock/Unlock";
import LoginModal from "features/loginModal/ContainerLoginModal";
import Logo from "app/images/Entretien.png";

const divStyle = {
  height: "40px",
  width: "40px",
};

const appBarStyle = {
  background: "white",
};

const container = {
  width: "1170px",
  margin: "auto",
  maxWidth: "90vw",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "@media (max-width: 768px)": {
    justifyContent: "center",
  },
};

const userAvatar = {
  width: "1.875rem",
  height: "1.875rem",
  borderRadius: "50%",
  marginLeft: "1rem",
};

// const forbidden = {
//   width: "1.5rem",
//   height: "1.5rem",
//   marginRight: "8px",
// };

// #E89A3A adobe color

const Brand = (props) => (
  <Typography {...props} variant="h6" style={{ flexGrow: 1, display: "block" }}>
    <Link component={RouterLink} to="/" style={{ color: "black" }}>
      <div className="logo-text">
        <img src={Logo} style={divStyle} alt="icon" />
      </div>
    </Link>
  </Typography>
);

const StyledBrand = styled(Brand)`
  a {
    .logo-text {
      display: flex;
      align-items: center;
    }
    &:hover {
      text-decoration: none;
    }
  }
`;

const Navbar = (props) => {
  const StyledToolbar = styled(Toolbar)`
    @media (max-width: 768px) {
      justify-content: center;
    }
  `;

  const StyledLoginButton = styled(Button)`
    text-transform: capitalize;
    background-color: #615104;
    color: white;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 0 30px rgba(0, 0, 0, 0.075);
    @media (max-width: 768px) {
      .login-text {
        display: none;
      }
    }
  `;

  const StyledCustomSessionButton = styled(Button)`
    text-transform: capitalize;
    background-color: #ffd700; /* Yellow color */
    color: black;
    margin-right: 1rem;
    .custom-session-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block; /* Or inline-block */
      vertical-align: middle;
    }
    .custom-session-icon {
      vertical-align: middle;
      margin-right: 0.5rem; /* Space between icon and text on desktop */
    }
    @media (max-width: 768px) {
      min-width: 0; /* Allow button to shrink */
      padding: 6px 8px; /* Adjust padding for icon-only */
      .custom-session-text {
        display: none;
      }
      .custom-session-icon {
        margin-right: 0; /* No margin when text is hidden */
      }
    }
  `;

  const StyledQuestionsButton = styled(Button)`
    text-transform: capitalize;
    background-color: #4caf50; /* Green color */
    color: white;
    margin-right: 1rem;
    .questions-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block; /* Or inline-block */
      vertical-align: middle;
    }
    .questions-icon {
      vertical-align: middle;
      margin-right: 0.5rem; /* Space between icon and text on desktop */
    }
    @media (max-width: 768px) {
      min-width: 0; /* Allow button to shrink */
      padding: 6px 8px; /* Adjust padding for icon-only */
      .questions-text {
        display: none;
      }
      .questions-icon {
        margin-right: 0; /* No margin when text is hidden */
      }
    }
  `;

  const { currentUser } = props;
  const location = useLocation();
  const isCustomSessionPage = location.pathname === "/custom-session";
  const isQuestionsPage = location.pathname === "/questions";
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    setOpen(false);
  }, [currentUser]);

  // https://github.com/omerevrencomtr/react_example/blob/569a2a5c277d58575f58667acf5b77ee1850d868/src/app/pages/home/google-material/navigation/LinksExamplesPage.js
  return (
    <div>
      <AppBar position="fixed" style={appBarStyle}>
        <StyledToolbar style={container}>
          <StyledBrand className="navbar-brand" />
          {/* Add button for Custom Session page, hidden if already on the page */}
          {!isCustomSessionPage && (
            <StyledCustomSessionButton
              component={RouterLink}
              to="/custom-session"
              className="navbar-custom-session"
              variant="contained"
            >
              <FlareIcon className="custom-session-icon" />
              <Typography variant="button" className="custom-session-text">
                Session personnalisée
              </Typography>
            </StyledCustomSessionButton>
          )}
          {/* Add button for Questions page, hidden if already on the page */}
          {!isQuestionsPage && (
            <StyledQuestionsButton
              component={RouterLink}
              to="/questions"
              className="navbar-questions"
              variant="contained"
            >
              <AssessmentIcon className="questions-icon" />
              <Typography variant="button" className="questions-text">
                Questions
              </Typography>
            </StyledQuestionsButton>
          )}
          {currentUser && currentUser.isPremium ? (
            <img
              style={{ width: "28px", height: "28px" }}
              src={PremiumIcon}
              className="navbar-premium-icon"
              alt="Premium Icon"
            />
          ) : (
            <>
              <Unlock />
            </>
          )}
          {currentUser ? (
            <>
              {currentUser.photoURL ? (
                <img
                  src={currentUser.photoURL}
                  alt="User Avatar"
                  style={userAvatar}
                  className="navbar-user-avatar"
                />
              ) : (
                // Fallback to AccountCircleIcon if no photoURL
                <AccountCircleIcon
                  style={{ ...userAvatar, color: "grey" }} // Explicitly set color to grey
                  className="navbar-user-avatar"
                />
              )}
              <Menu className="navbar-menu" />
            </>
          ) : (
            <>
              <StyledLoginButton
                // onClick={signInWithGoogle}
                onClick={handleOpen}
                id="signin"
                // color="primary"
                variant="contained"
                className="navbar-login-button"
              >
                <AccountCircleIcon style={{ marginRight: "0.5rem" }} />
                <span className="login-text">Connexion</span>
              </StyledLoginButton>
            </>
          )}
        </StyledToolbar>
      </AppBar>
      <LoginModal isOpen={open} handleClose={handleClose} />
    </div>
  );
};

export default Navbar;
